require('./angular-sanitize');
module.exports = 'ngSanitize';



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-sanitize/index.js
// module id = AFu3
// module chunks = 1